import PatientStatus from "@/model/PatientStatus";
import { Instant } from "@js-joda/core";
import { Patient } from "../../model/Patient";
import { daysBetween } from "../../util/date-utils";

export const daysSinceReviewFor = (patient: Patient) => {
  const lastReviewTime = patient.lastReviewTime ?? patient.firstReadingTime;
  if (!lastReviewTime) {
    return null;
  }
  return daysBetween(lastReviewTime, Instant.now());
};

export const patientStatusOrder = (status: PatientStatus) => {
  switch (status) {
    case "monitoring":
    case "postpartum-monitoring":
      return 0;
    case "onboarding":
      return 1;
    case "offboarded":
      return 2;
    default:
      return 3;
  }
};

export const formatDays = (days: number) => (days === 1 ? `${days} day` : `${days} days`);

export const singleLine = (text: string) => <span className="text-nowrap">{text}</span>;
